<script type="text/babel">
import Lock from './Lock'

export default {
    mixins: [Lock],

    watch: {
        disabled(now, before) {
            if (now && !before) {
                this.focusOriginal()
            }
        },
    },

    methods: {
        focusOriginal() {
            if (this.returnFocus && this.originalFocusedElement && this.originalFocusedElement.focus) {
                this.originalFocusedElement.focus()
            }
        },
    },
}
</script>
